import Vue from 'vue'
import Vuex from 'vuex'

import db from './db'
import map from './map'
import user from './user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    db,
    map,
    user
  }
})

export default store
